import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import "../components/style.css"
import { FaLine } from "react-icons/fa";
import Line_OA from "../img/LineOA.png";
require("moment/locale/th");

const LineOA = () => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return (
        <>
            <Button type="button" className="btn btn-success w-100 mt-1" style={{ fontSize: "13px", border: "none" }} onClick={handleShow}>
                Line OA <FaLine style={{ fontSize: "25px" }}  />
            </Button>

            <Modal
                show={show}
                onHide={handleClose}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                backdrop="static"
                centered
                keyboard={true}
            >
                <Modal.Body>
                    <div className="rounded">
                        <div className="px-3 pt-2">
                            <div className="col-sm-12 col-xs-12">
                                <div className="card-body rounded">
                                    <div className="row d-flex p-2 mb-2">
                                        <div className="col-3 col-xs-12 card-title text-center fs-5 w-100 fs-3" style={{ color: "#000000" }}>
                                            <div className="fw-bold" style={{ fontSize: "25px" }}>QR Code Line OA</div>
                                        </div>
                                        <hr></hr>
                                    </div>
                                    <form className="row ">
                                        <div className="col-md-12 text-center" style={{ backgroundColor: "#FFFFFF" }} >
                                       <img src={Line_OA} alt="lineOA"  style={{ maxHeight: "180px" }}></img>
                                        </div>
                                    </form>
                                    {/* <!-- End No Labels Form --> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="col-md-12 col-12 gap-3 d-flex justify-content-center">
                        <Button variant="primary" onClick={handleClose} >
                            ตกลง
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default LineOA